import { createFileRoute, redirect } from "@tanstack/react-router";
import { finalInternalPath } from "@/lib/blog-internal-links";
import { withQuery } from "@/lib/redirect-query";

// Old WordPress section /education/ (19 referring domains) and its posts,
// /education/<slug>/. WordPress sent /education/ to
// /considering-hair-restoration/ and the FAQ page to /hair-transplant-faqs/.
// A post goes to /<slug>/ through the same maps as blog links.
const SECTION_TARGETS: Record<string, string> = {
  "": "/considering-hair-restoration/",
  "frequently-asked-questions": "/hair-transplant-faqs/",
};

export const Route = createFileRoute("/education/$")({
  beforeLoad: ({ params, location }) => {
    const rest = (params._splat ?? "").replace(/^\/+|\/+$/g, "");
    const target = SECTION_TARGETS[rest] ?? (rest.includes("/") ? "/hair-loss-blog/" : finalInternalPath(`/${rest}/`));
    throw redirect({ href: withQuery(target, location.searchStr), statusCode: 301 });
  },
});
